"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentInvoicedStatusCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
require("./index.scss");
const className = 'allotment-status-cell';
const statusNameMap = {
    open: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column/Status:open', defaultMessage: 'Open' })),
    invoiced: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column/Status:invoiced', defaultMessage: 'Invoiced' })),
};
const AllotmentInvoicedStatusCell = (props) => {
    const { invoicedStatus } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        invoicedStatus,
    ]);
    return (react_1.default.createElement("div", { className: classNames }, statusNameMap[invoicedStatus]));
};
exports.AllotmentInvoicedStatusCell = AllotmentInvoicedStatusCell;
//# sourceMappingURL=index.js.map